// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-AddressBook__addressBook__root","title":"cmp-AddressBook__addressBook__title"};